import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';

//import clsx from 'clsx';
//import { useDispatch, useSelector } from "react-redux";


interface IProps {
  litResult: any;
  }


  const SafetyColor = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { litResult } = props;

    const [scScorecommentary, setScScorecommentary] = useState("Analyzing...");


    useEffect(() => {
        if (litResult?.color) {
          
          if (litResult?.color === 'green') {
            setScScorecommentary("The Psychological Safety of your audience was high.  This is great news, and shows that the audience was prepared to learn and remember the content.");
          } else if (litResult?.color === 'yellow') {
            setScScorecommentary(`Your audience was at a moderate Psychological Safety level during this experience. Think of safety like the 'bandwidth' your audience is allocating. What could you do to help them feel safer?`);
          } else if (litResult?.color === 'red') {
            setScScorecommentary(`The overall Psychological Safety of your audience was pretty low. This will make it much harder for them to remember or take action on your content. You will need to fix this to improve the quality of this experience.`);
          } 
        }
      }, [props]);
    

      const goToAnalyze = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };

      const getImageUrl = () => {
        const imageName = litResult.color?.trim()?.toLowerCase() + "-solid.png";
        return "/assets/images/lit/" + imageName;
      }

    //console.log(`i score immersiondata = ${JSON.stringify(immersionData)}`);


    return (

        <Grid item xs={4} style={{textAlign: 'center'}}>
          <img src={getImageUrl()} className={classes.iconImage} />
            
            <Typography variant="body1" className={classes.sectionTitle}>Psychological Safety</Typography>
            <Typography variant="body1" className={classes.bodyText}>{scScorecommentary}</Typography>
            <Link className={classes.actionLink} onClick={goToAnalyze}>
                <Typography variant="body1" className={classes.foo}>See the Detail</Typography>
            </Link>
            
          </Grid>

    )


  }

  export default SafetyColor;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    iconImage: {
      width: '80px',
      height: '80px',
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));